import css from 'styled-jsx/css';

export default css`
  .redirection-loading {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    text-align: center;
  }

  .redirection-loading .loading-wrapper {
    display: flex;
    flex-grow: 1;
    justify-content: center;
  }

  .redirection-loading .loading {
    margin-bottom: 1.5em;
  }

  .redirection-loading .loading > span {
    display: block;
    line-height: 1.2;
    margin-bottom: 1.2em;
  }

  .redirection-loading .source_image {
    margin-bottom: 1.3em;
  }

  .redirection-loading .source_image img {
    width: 150px;
  }
`;



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/components/RedirectingToLayout/styles.js